import React from 'react';
import { useParams } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import ListTemplate from '../../../Reusable_Components/ListTemplate';

const CustomerNoteList = ({ customerId: propCustomerId }) => {
  const { customerId: routeCustomerId } = useParams();
  const customerId = propCustomerId || routeCustomerId;

  const decodedCustomerId = customerId ? atob(customerId).replace(/\D/g, '') : '';
  const fetchUrl = decodedCustomerId
    ? `${API_DOMAIN}${API_ROUTES.customerNote}?customer=${decodedCustomerId}`
    : `${API_DOMAIN}${API_ROUTES.customerNote}`;

  const columns = [
    { label: 'Customer', value: (item) => item.customer?.name || 'Unknown' },
    { label: 'User', value: (item) => item.user?.username || 'Unknown' },
    { label: 'Text', value: 'text' },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(`note-${id}`);
    window.location.href = `/customer/note/details/${encodedId}`;
  };

  return (
    <div>
      <h1>Customer Notes</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default CustomerNoteList;
